/* eslint-disable no-console,no-undef */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { ButtonV1, CalendarWrapperV1,StyledModalV1 } from "../PeopleHomeV2/ManageBuddies/styles";
import { CalendarHeader } from "../ChallengeDetailsV2/InviteAmigoPopUp/styles";
import { BirthdayWrapper, WishCard, WishButton, PreviousButton,/* NewActivityDropdownCommon,*/ UserInitialsMain, NoData } from "./styles";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { getAmigoBirthday,getAmigoBirthdayForManagerView, getWorkAnniversary,getWorkAnniversaryForManagerView, fetchAnniversaryBirthdayUsers, getCompanyLocation, getCompanyDepartment } from "../../redux/actions";
import { ImageUrl } from "../../utils/constants";
import { convertMonthFromDate, findMonth, fetchApi, getInitials } from '../../utils/methods';
import moment from 'moment';
// import {months} from '../../../mockData';
// import { TitleContainer } from './styles';
import {StyledHeader, CloseIcon,HeaderTextV1} from '../PhotoAndPostFlow/styles';
import { AdminCloseIcon, BirthdayAnniversaryFilterIcon, CalendarNextArrow, CalendarPrevArrow } from '../../utils/icons';
// import { Dropdown } from 'react-bootstrap';
import { toast } from "react-toastify";
import {GetUserCelebrationByFilter} from '../../redux/constants/apiConstants';
import BirthdayAnniversaryFilter from "./BirthdayAnniversaryFilter";


class BirthdayWishPopup extends Component {
  constructor(props) {
    super(props);
    const date = new Date();
    this.state = {
      currentMonth: findMonth(date.getMonth()).toLowerCase(),
      activityArrow: false,
      currentMonthCountStore:[date.getMonth()+1],
      selectedLocationId: [],
      selectedLocationValue: "All",
      selectedDepartmentId: [],
      selectedDepartmentValue: "All",
      anniversaryBirthdayUsersData: [],
      popupType: props?.popupType?props?.popupType:2,
      currentMonthName: findMonth(date.getMonth()).toLowerCase(), 
      currentYear: date.getFullYear(),
      isDropdownOpen:false,
      selectedDepartments:[],
      selectedLocations:[],
    }
    this.setIsDropdownOpen = this.setIsDropdownOpen.bind(this);
  }

  componentDidMount() {
    const { getAmigoBirthday,getAmigoBirthdayForManagerView, getWorkAnniversary,getWorkAnniversaryForManagerView, fetchAnniversaryBirthdayUsers, getCompanyLocation, getCompanyDepartment, user,location } = this.props;
    const {popupType, selectedLocationId, selectedDepartmentId, currentMonthCountStore} = this.state;
    // getAmigoBirthday();
    // getWorkAnniversary();
    // location.pathname.includes('manager') ? getAmigoBirthdayForManagerView() : getAmigoBirthday();
    // location.pathname.includes('manager') ? getWorkAnniversaryForManagerView() : getWorkAnniversary();
    if (location.pathname.includes('manager')) {
      getAmigoBirthdayForManagerView();
      getWorkAnniversaryForManagerView();
    } else {
      getAmigoBirthday();
      getWorkAnniversary();
    }
    fetchAnniversaryBirthdayUsers();
    getCompanyLocation(user?.company_id,1);
    getCompanyDepartment(user?.company_id,1);
    this.getBirthdayAndAnniversaryDataByFilter(popupType, currentMonthCountStore, selectedLocationId, selectedDepartmentId,location.pathname.includes('manager') ? 1:0)
  }

 



  getBirthdayAndAnniversaryDataByFilter = async(type, month, location, department,isManager)=>{
    const payload = {
      city_state_ids: location,
      department_ids: department,
      months:month,
      type: type,
      is_manager_view: isManager,
    }

    try {
      const res = await fetchApi(GetUserCelebrationByFilter,"POST",payload);
      if (res.status === "success") {
        this.setState({anniversaryBirthdayUsersData: res?.data})
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  setIsDropdownOpen() {
    this.setState({ isDropdownOpen: !this.state.isDropdownOpen });
  }

 

  handleRequest = (data, filter) => {
    const { peerCallBack, hidePopup } = this.props;
    hidePopup();
    peerCallBack(data, 0, filter);
  };

  handleRequestAnniversary = (data,filter) => {
    const { peerCallBack, hidePopup } = this.props;
    hidePopup();
    peerCallBack(data, 1, filter);
  };

  onSelect = (name, value, id) => {
    const {popupType, selectedLocationId, selectedDepartmentId} = this.state;
    this.setState({
      [name]: value,
      currentMonthCountStore: id
    }, () => {
      this.getBirthdayAndAnniversaryDataByFilter(popupType, id, selectedLocationId, selectedDepartmentId)
    })
  };



  // handleMonthChange = (direction) => {
  //   const monthNames = [
  //     "january", "february", "march", "april", "may", "june",
  //     "july", "august", "september", "october", "november", "december"
  //   ];
  
  //   let currentIndex = monthNames.indexOf(this.state.currentMonth);
  //   let newIndex = currentIndex + direction;
  //   let newYear = this.state.currentYear;
  
  //   if (newIndex < 0) {
  //     newIndex = 11;
  //     newYear -= 1;
  //   } else if (newIndex > 11) {
  //     newIndex = 0;
  //     newYear += 1;
  //   }
  
  //   this.setState({
  //     currentMonth: monthNames[newIndex],
  //     currentYear: newYear,
  //   });
  // };


  handleMonthChange = (direction) => {
    const monthNames = [
      "january", "february", "march", "april", "may", "june",
      "july", "august", "september", "october", "november", "december"
    ];
  
    const { currentMonth, currentYear, popupType, selectedLocationId, selectedDepartmentId } = this.state;
  
    let currentIndex = monthNames.indexOf(currentMonth);
    let newIndex = currentIndex + direction;
    let newYear = currentYear;
  
    if (newIndex < 0) {
      newIndex = 11;
      newYear -= 1;
    } else if (newIndex > 11) {
      newIndex = 0;
      newYear += 1;
    }
  
    const newMonth = monthNames[newIndex];
  
    this.setState(
      {
        currentMonth: newMonth,
        currentYear: newYear,
        currentMonthCountStore: [newIndex + 1] 
      },
      () => {
        this.getBirthdayAndAnniversaryDataByFilter(
          popupType,
          this.state.currentMonthCountStore, 
          selectedLocationId,
          selectedDepartmentId,
          location.pathname.includes('manager') ? 1:0
        );
      }
    );
  };
  

  onSelectValue = (idState, valueState, id, value) => {
    const {popupType, selectedDepartmentId, currentMonthCountStore} = this.state;
    this.setState({
      [idState]: id?id:0,
      [valueState]: value
    }, () => {
      this.getBirthdayAndAnniversaryDataByFilter(popupType, currentMonthCountStore, id?id:0, selectedDepartmentId,location.pathname.includes('manager') ? 1:0)
    })
  };

  onSelectValueDepartment = (idState, valueState, id, value) => {
    const {popupType, selectedLocationId, currentMonthCountStore} = this.state;
    this.setState({
      [idState]: id?id:0,
      [valueState]: value
    }, () => {
      this.getBirthdayAndAnniversaryDataByFilter(popupType, currentMonthCountStore, selectedLocationId, id?id:0,location.pathname.includes('manager') ? 1:0)
    })
  };

  containsDefaultPng = (str) => {
    const defaultPngFound = str?.includes("default.png");
    return defaultPngFound;
  }
  

  handleSelectedDepartments = (value) =>{
    this.setState({selectedDepartments:value})
  }

  handleSelectedLocations = (value) =>{
    this.setState({selectedLocations:value})
  }

  // handleMonthChange = (direction) => {
  //   let newMonth = this.state.currentMonth1 + direction;
  //   let newYear = this.state.currentYear;
  
  //   if (newMonth < 0) {
  //     newMonth = 11; // December of the previous year
  //     newYear -= 1;
  //   } else if (newMonth > 11) {
  //     newMonth = 0; // January of the next year
  //     newYear += 1;
  //   }
  
  //   this.setState({
  //     currentMonth1: newMonth,
  //     currentYear: newYear,
  //   });
  // };

  render() {
    const { show, birthdayList, hidePopup, showBirthday, anniversaryList, t, locationDetails, departmentDetails,user} =this.props;
    const {currentMonth,  selectedLocationId, /*selectedLocationValue,*/ selectedDepartmentId,/* selectedDepartmentValue,*/ anniversaryBirthdayUsersData, currentMonthCountStore,isDropdownOpen,popupType,selectedLocations,selectedDepartments} =this.state;
    const filteredLocations = locationDetails && locationDetails.filter((item) => item.id !== null);
    const filteredDepartments = departmentDetails && departmentDetails.filter((item) => item.id !== null);
   
    const date = new Date();
    const month = findMonth(date.getMonth()).toLowerCase();
    return  (showBirthday?
      <StyledModalV1 show={show} width={"822px"} height="auto">
        <StyledHeader background isBorder={"1px solid #EFEFEF !important"} isPadding={"16px 24px"}>
          {<HeaderTextV1  color>{(t("Birthdays "))}</HeaderTextV1>}
          <CloseIcon onClick={() => hidePopup()}>
            {AdminCloseIcon()}
          </CloseIcon>
        </StyledHeader>
        <CalendarHeader height="100%" padding={"12px 24px"}>
        
          {/* <div className="label">Month</div>
            <div className="filter-dropdown">
              <TitleContainer paddingV="0px !important">
                <NewActivityDropdownCommon
                  padding={"10px 8px"}
                  height="42px"
                  onClick={() => this.setState({ activityArrow: !this.state.activityArrow })}
                >
                  <Dropdown.Toggle>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center", color:currentMonth? "#005C87":"#005C874D",fontFamily:"Rubik-Medium", width:"100%"}}>
                      <div style={{color: "#005C87",textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"}}>{currentMonth?currentMonth:"Select Option"}</div>
                      {<div>        
                        <img
                          alt="image"
                          src={ImageUrl + "/social-feed/dropdown-arrow.svg"}
                        />
                      </div>}
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {months && months.length > 0 && months.map((list) => (
                      <Dropdown.Item 
                        key={list.id}
                        onClick={() => this.onSelect('currentMonth', list.key, list.id)}
                        active={currentMonth == list.name}
                      >
                        {this.props.t(list.name)}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </NewActivityDropdownCommon>
              </TitleContainer>
            </div> */}

          <CalendarWrapperV1 id="calendar-header">
            <ButtonV1 id="prev-button" onClick={() => this.handleMonthChange(-1)}>
              {CalendarPrevArrow(8,14)}
            </ButtonV1>
            {/* <span id="month-name" className="headerTitle">
                {new Date(currentYear, currentMonth1).toLocaleString("default", {
                  month: "long",
                })}
              </span> */}
            <span id="month-name" className="headerTitle">
              {currentMonth.charAt(0).toUpperCase() + currentMonth.slice(1)}
            </span>
            <ButtonV1 id="next-prev" onClick={() => this.handleMonthChange(1)}>
              {CalendarNextArrow(8,14)}
            </ButtonV1>
         
          </CalendarWrapperV1>

          {(filteredLocations && filteredLocations.length > 0 || filteredDepartments && filteredDepartments.length > 0 ) ? (<div style={{cursor:"pointer"}}  onClick={() => this.setState({isDropdownOpen:!this.setState.isDropdownOpen})}>{BirthdayAnniversaryFilterIcon()}</div>):null}
          {isDropdownOpen && (filteredLocations.length || filteredDepartments.length ) ? (<BirthdayAnniversaryFilter handleSelectedDepartments={this.handleSelectedDepartments} handleSelectedLocations={this.handleSelectedLocations} selectedLocations={selectedLocations} selectedDepartments={selectedDepartments} setIsDropdownOpen={this.setIsDropdownOpen}  locationData={filteredLocations} departmentData={filteredDepartments} isDropdownOpen={isDropdownOpen} hidePopup={hidePopup}  onSelectDepartment={(id) => {
            this.setState({ selectedDepartmentId: id });
            this.getBirthdayAndAnniversaryDataByFilter(popupType, currentMonthCountStore, selectedLocationId, id?id:0,location.pathname.includes('manager') ? 1:0);
          }}
          onSelectLocation={(id) => {
            this.setState({ selectedLocationId: id });
            this.getBirthdayAndAnniversaryDataByFilter(popupType, currentMonthCountStore, id?id:0, selectedDepartmentId,location.pathname.includes('manager') ? 1:0);}} />) : null}
           
          
          {/* {locationDetails?.length>0&&<div className="dropdown-wrapper">
            <div className="label">Location</div>
            <div className="filter-dropdown">
              <TitleContainer paddingV="0px !important">
                <NewActivityDropdownCommon
                  padding={"10px 8px"}
                  widthdropdown
                  height="42px"
                  margin="0px"
                  onClick={() => this.setState({ activityArrow: !this.state.activityArrow })}
                >
                  <Dropdown.Toggle>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center", color:selectedLocationValue? "#005C87":"#005C874D",fontFamily:"Rubik-Medium", width:"100%"}}>
                      <div style={{color: "#005C87",textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"}}>{selectedLocationValue?selectedLocationValue:"Select Option"}</div>
                      {<div>        
                        <img
                          alt="image"
                          src={ImageUrl + "/social-feed/dropdown-arrow.svg"}
                        />
                      </div>}
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {locationDetails && locationDetails?.map((list) => (
                      <Dropdown.Item 
                        key={list.id}
                        onClick={() => this.onSelectValue('selectedLocationId','selectedLocationValue', list.id, list.location)}
                        active={selectedLocationId == list.id}
                      >
                        {this.props.t(list.location)}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </NewActivityDropdownCommon>
              </TitleContainer>
            </div>
          </div>} */}
          {/* {departmentDetails?.length>0&&<div className="dropdown-wrapper">
            <div className="label">Department</div>
            <div className="filter-dropdown">
              <TitleContainer paddingV="0px !important">
                <NewActivityDropdownCommon
                  padding={"10px 8px"}
                  widthdropdown
                  margin="0px"
                  height="42px"
                  marginleft="-50px"
                  onClick={() => this.setState({ activityArrow: !this.state.activityArrow })}
                >
                  <Dropdown.Toggle>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center", color:selectedDepartmentValue? "#005C87":"#005C874D",fontFamily:"Rubik-Medium", width:"100%"}}>
                      <div style={{color: "#005C87",textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"}}>{selectedDepartmentValue?selectedDepartmentValue:"Select Option"}</div>
                      {<div>        
                        <img
                          alt="image"
                          src={ImageUrl + "/social-feed/dropdown-arrow.svg"}
                        />
                      </div>}
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {departmentDetails && departmentDetails?.map((list) => (
                      <Dropdown.Item 
                        key={list.id}
                        onClick={() => this.onSelectValueDepartment('selectedDepartmentId','selectedDepartmentValue', list.id, list.department)}
                        active={selectedDepartmentId == list.id}
                      >
                        {this.props.t(list.department)}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </NewActivityDropdownCommon>
              </TitleContainer>
            </div>
          </div>} */}
        </CalendarHeader>
        {currentMonth==month && selectedLocationId==0 && selectedDepartmentId==0?<BirthdayWrapper flex={(birthdayList.upcoming_birthday===0&&birthdayList.today_birthday===0)||(birthdayList.upcoming_birthday===0&&birthdayList.recent_birthday===0)||(birthdayList.today_birthday===0&&birthdayList.recent_birthday===0)}>
          {birthdayList && birthdayList.today_birthday && birthdayList.today_birthday.length?<div className="title">{this.props.t("Today")}</div>:null}
          {birthdayList?.today_birthday?.length>0&&<div className="birthdayWrapper">
            {birthdayList && birthdayList.today_birthday && birthdayList.today_birthday.length ?
              birthdayList.today_birthday.map((data, index) => (
                <WishCard key={index}>
                  <div className="wrapper">
                    <div className="profile">
                      {!this.containsDefaultPng(data.profile_image)?
                        <img src={ImageUrl + "/" + data.profile_image} />:
                        <UserInitialsMain border isBg color="#184A61" size={"24px"}>{`${getInitials(data?.name)}`}</UserInitialsMain>}
                    </div>
                    <div className="details">
                      <div className="name">{data.name}</div>
                      <div className="date">{convertMonthFromDate(moment(data.birthday).format('D, MMMM'), this.props)}</div>
                      <div className="location"> { data?.department ? data?.department:null} {data?.department && data?.location!="" && ' | '} {data?.location ? data?.location?.replace(/,/g, '') : null}</div>
                      {user?.uid!=data?.uid?<WishButton isBackground={"#FEFEFE"} isWidth={"262px"} disable={data?.show_recognition?0:1} onClick={data?.show_recognition?() => this.handleRequest(data):null}>
                        {data?.show_recognition ? "Share a Post" : "Posted"}
                      </WishButton>:
                        <WishButton isBackground={"#FEFEFE"} isWidth={"262px"}  disable>
                          Share a Post
                        </WishButton>
                      }
                    </div>

                  </div>
                
                </WishCard>
              )):
              null
            }
          </div>}


          {birthdayList && birthdayList.recent_birthday && birthdayList.recent_birthday.length?<div className="title">{this.props.t("Previously")}</div>:null}
          {birthdayList?.recent_birthday?.length>0&&<div className="birthdayWrapper">
            {birthdayList && birthdayList.recent_birthday && birthdayList.recent_birthday.length?
              birthdayList.recent_birthday && birthdayList.recent_birthday.map((data, index) => (
                <WishCard key={index}>
                  <div className="wrapper">
                    <div className="profile">
                      {!this.containsDefaultPng(data.profile_image)?
                        <img src={ImageUrl + "/" + data.profile_image} />:
                        <UserInitialsMain border  isBg color="#184A61" size={"24px"}>{`${getInitials(data?.name)}`}</UserInitialsMain>}
                    </div>
                    <div className="details">
                      <div className="name">{data.name}</div>
                      <div className="date">{convertMonthFromDate(moment(data.birthday).format('D, MMMM'), this.props)}</div>
                      <div className="location"> { data?.department ? data?.department:null} {data?.department && data?.location && ' | '} {data?.location ? data?.location?.replace(/,/g, '') : null}</div>
                      {user?.uid!=data?.uid?<PreviousButton disable={data?.show_recognition?0:1} onClick={data?.show_recognition?() => this.handleRequest(data, 1):null}>
                        {data?.show_recognition ? "Share a Post" : "Posted"}
                      </PreviousButton>:<PreviousButton disable>Posted</PreviousButton>}
                    </div>
                  </div>
                 
                </WishCard>
              )):
              null
            }
          </div>}

          {birthdayList && birthdayList.upcoming_birthday && birthdayList.upcoming_birthday.length?<div className="title">Upcoming</div>:null}
          {birthdayList?.upcoming_birthday?.length>0&&<div className="birthdayWrapper">
            {birthdayList && birthdayList.upcoming_birthday && birthdayList.upcoming_birthday.length?
              birthdayList.upcoming_birthday.map((data, index) => (
                <WishCard key={index}>
                  <div className="wrapper">
                    <div className="profile">
                      {!this.containsDefaultPng(data.profile_image)?
                        <img src={ImageUrl + "/" + data.profile_image} />:
                        <UserInitialsMain size={"24px"} border isBg color="#184A61">{`${getInitials(data?.name)}`}</UserInitialsMain>}
                    </div>
                    <div className="details">
                      <div className="name">{data.name}</div>
                      <div className="date">{convertMonthFromDate(moment(data.birthday).format('D, MMMM'), this.props)}</div>
                      <div className="location"> { data?.department ? data?.department:null} {data?.department && data?.location  && ' | '} {data?.location ? data?.location?.replace(/,/g, '') : null}</div>
                    </div>
                  </div>
                </WishCard>
              )):
              null
            }
          </div>}

        </BirthdayWrapper>:
          <BirthdayWrapper style={{display:"block"}}>
            {anniversaryBirthdayUsersData && anniversaryBirthdayUsersData.birthday && anniversaryBirthdayUsersData?.birthday?.length>0 && <div className="title">{currentMonthCountStore==date.getMonth()+1?"This month": currentMonthCountStore<date.getMonth()+1?this.props.t("Previously"): this.props.t("Upcoming")}</div>}
            <div className="birthdayWrapper">
              {anniversaryBirthdayUsersData && anniversaryBirthdayUsersData.birthday && anniversaryBirthdayUsersData?.birthday?.length>0 ?
                anniversaryBirthdayUsersData?.birthday?.map((data, index) => {
                  const birthdayDate = moment(data.birthday); // Parse the birthday date
                  const currentDate = moment(); // Get the current date
              
                  // Extract month and day for comparison
                  const birthdayMonth = birthdayDate.month(); // 0-11 (January is 0)
                  const birthdayDay = birthdayDate.date(); // 1-31
                  const currentMonth = currentDate.month(); // 0-11
                  const currentDay = currentDate.date(); // 1-31
              
                  // Show button for past months entirely, or current month up to today
                  const selectedMonthNum = Array.isArray(currentMonthCountStore) ? currentMonthCountStore[0] : currentMonthCountStore;
                  const todayMonthNum = date.getMonth() + 1;
                  const isBirthdayVisible = selectedMonthNum < todayMonthNum ||
                    (birthdayMonth === currentMonth && birthdayDay <= currentDay);
                  return(
                    <WishCard key={index}>
                      <div className="wrapper">
                        <div className="profile">
                          {!this.containsDefaultPng(data.profile_image)?
                            <img src={ImageUrl + "/" + data.profile_image} />:
                            <UserInitialsMain size={"24px"} border isBg color="#184A61">{`${getInitials(data?.full_name)}`}</UserInitialsMain>}
                        </div>
                        <div className="details">
                          <div className="name">{data.full_name}</div>
                          <div className="date">{convertMonthFromDate(moment(data.birthday).format('D, MMMM'), this.props)}</div>
                          <div className="location"> { data?.department ? data?.department:null} {data?.department&&data?.location!="" && "|"} {data?.location ? data?.location?.replace(/,/g, ''): null}</div>
                          {isBirthdayVisible && user?.uid!=data?.uid?
                            <WishButton isWidth={"262px"} disable={data?.show_recognition?0:1} onClick={data?.show_recognition?() => this.handleRequest({...data, name: data.full_name}, 1):null}>
                              {data?.show_recognition ? "Share a Post" : "Posted"}
                            </WishButton>:/*<WishButton isWidth={"262px"} disable>Share a Post</WishButton>*/ null}
                        </div>
                       
                      </div>
                    </WishCard>)
                }):<NoData>No birthdays found in the selected filter</NoData>}
            </div>       
          </BirthdayWrapper>
        }
      </StyledModalV1>: 
      <StyledModalV1 show={show} width={"822px"} height="auto">
        <StyledHeader background  isBorder={"1px solid #EFEFEF !important"} isPadding={"16px 24px"}>
          {<HeaderTextV1 color>{('Work Anniversaries')}</HeaderTextV1>}
          <CloseIcon onClick={() => hidePopup()}>
            {AdminCloseIcon()}
          </CloseIcon>
        </StyledHeader>
        <CalendarHeader height="100%"  padding={"12px 42px"}>
          {/* <div className="dropdown-wrapper"> */}
          {/* <div className="label">Month</div>
          <div className="filter-dropdown">
            <TitleContainer paddingV="0px !important">
              <NewActivityDropdownCommon
                padding={"10px 8px"}
                widthdropdown
                margin="0px"
                height="42px"
                onClick={() => this.setState({ activityArrow: !this.state.activityArrow })}
              >
                <Dropdown.Toggle>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center", color:currentMonth? "#005C87":"#005C874D",fontFamily:"Rubik-Medium", width:"100%"}}>
                    <div style={{color: "#005C87",textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"}}>{currentMonth?currentMonth:"Select Option"}</div>
                    {<div>        
                      <img
                        alt="image"
                        src={ImageUrl + "/social-feed/dropdown-arrow.svg"}
                      />
                    </div>}
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {months && months.length > 0 && months.map((list) => (
                    <Dropdown.Item 
                      key={list.id}
                      onClick={() => this.onSelect('currentMonth', list.key, list.id)}
                      active={currentMonth == list.name}
                    >
                      {this.props.t(list.name)}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </NewActivityDropdownCommon>
            </TitleContainer>
          </div> */}

          <CalendarWrapperV1 id="calendar-header">
            <ButtonV1 id="prev-button" onClick={() => this.handleMonthChange(-1)}>
              {CalendarPrevArrow(8,14)}
            </ButtonV1>
            {/* <span id="month-name" className="headerTitle">
                {new Date(currentYear, currentMonth1).toLocaleString("default", {
                  month: "long",
                })}
              </span> */}
            <span id="month-name" className="headerTitle">
              {currentMonth.charAt(0).toUpperCase() + currentMonth.slice(1)}
            </span>
            <ButtonV1 id="next-prev" onClick={() => this.handleMonthChange(1)}>
              {CalendarNextArrow(8,14)}
            </ButtonV1>
         
          </CalendarWrapperV1>

          {(filteredLocations && filteredLocations.length > 0 || filteredDepartments && filteredDepartments.length > 0 ) ? <div style={{cursor:"pointer"}}  onClick={() => this.setState({isDropdownOpen:!this.setState.isDropdownOpen})}>{BirthdayAnniversaryFilterIcon()}</div>:null}
          {isDropdownOpen &&  (filteredLocations.length || filteredDepartments.length ) ? (<BirthdayAnniversaryFilter handleSelectedDepartments={this.handleSelectedDepartments} handleSelectedLocations={this.handleSelectedLocations}  selectedLocations={selectedLocations} selectedDepartments={selectedDepartments}  setIsDropdownOpen={this.setIsDropdownOpen}  locationData={filteredLocations} departmentData={filteredDepartments} isDropdownOpen={isDropdownOpen} hidePopup={hidePopup}  onSelectDepartment={(id) => {
            this.setState({ selectedDepartmentId: id });
            this.getBirthdayAndAnniversaryDataByFilter(popupType, currentMonthCountStore, selectedLocationId, id?id:0,location.pathname.includes('manager') ? 1:0);
          }}
          onSelectLocation={(id) => {
            this.setState({ selectedLocationId: id });
            this.getBirthdayAndAnniversaryDataByFilter(popupType, currentMonthCountStore, id?id:0, selectedDepartmentId,location.pathname.includes('manager') ? 1:0);}} />):null}
          {/* </div> */}
          {/* {locationDetails?.length>0&&<div className="dropdown-wrapper">
            <div className="label">Location</div>
            <div className="filter-dropdown">
              <TitleContainer paddingV="0px !important">
                <NewActivityDropdownCommon
                  padding={"10px 8px"}
                  widthdropdown
                  margin="0px"
                  height="42px"
                  onClick={() => this.setState({ activityArrow: !this.state.activityArrow })}
                >
                  <Dropdown.Toggle>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center", color:selectedLocationValue? "#005C87":"#005C874D",fontFamily:"Rubik-Medium", width:"100%"}}>
                      <div style={{color: "#005C87",textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"}}>{selectedLocationValue?selectedLocationValue:"Select Option"}</div>
                      {<div>        
                        <img
                          alt="image"
                          src={ImageUrl + "/social-feed/dropdown-arrow.svg"}
                        />
                      </div>}
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {locationDetails && locationDetails?.map((list) => (
                      <Dropdown.Item 
                        key={list.id}
                        onClick={() => this.onSelectValue('selectedLocationId','selectedLocationValue', list.id, list.location)}
                        active={selectedLocationId == list.id}
                      >
                        {this.props.t(list.location)}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </NewActivityDropdownCommon>
              </TitleContainer>
            </div>
          </div>}
          {departmentDetails?.length>0&&<div className="dropdown-wrapper">
            <div className="label">Department</div>
            <div className="filter-dropdown">
              <TitleContainer paddingV="0px !important">
                <NewActivityDropdownCommon
                  padding={"10px 8px"}
                  widthdropdown
                  margin="0px"
                  height="42px"
                  marginleft="-50px"
                  onClick={() => this.setState({ activityArrow: !this.state.activityArrow })}
                >
                  <Dropdown.Toggle>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center", color:selectedDepartmentValue? "#005C87":"#005C874D",fontFamily:"Rubik-Medium", width:"100%"}}>
                      <div style={{color: "#005C87",textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"}}>{selectedDepartmentValue?selectedDepartmentValue:"Select Option"}</div>
                      {<div>        
                        <img
                          alt="image"
                          src={ImageUrl + "/social-feed/dropdown-arrow.svg"}
                        />
                      </div>}
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {departmentDetails && departmentDetails?.map((list) => (
                      <Dropdown.Item 
                        key={list.id}
                        onClick={() => this.onSelectValueDepartment('selectedDepartmentId','selectedDepartmentValue', list.id, list.department)}
                        active={selectedDepartmentId == list.id}
                      >
                        {this.props.t(list.department)}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </NewActivityDropdownCommon>
              </TitleContainer>
            </div>
          </div>} */}
        </CalendarHeader>
        {currentMonth==month && selectedLocationId==0 && selectedDepartmentId==0?<BirthdayWrapper flex={(anniversaryList.recent_anniversary===0&&anniversaryList.today_anniversary===0)||(anniversaryList.upcoming_anniversary===0&&anniversaryList.today_anniversary===0)||(anniversaryList.recent_anniversary===0&&anniversaryList.today_anniversary===0)}>
          {anniversaryList && anniversaryList.today_anniversary && anniversaryList.today_anniversary.length?<div className="title">{this.props.t("Today")}</div>:null}
          {anniversaryList && anniversaryList.today_anniversary && anniversaryList.today_anniversary.length?<div className="birthdayWrapper">
            {anniversaryList && anniversaryList.today_anniversary && anniversaryList.today_anniversary.length?
              anniversaryList.today_anniversary.map((data, index) => (
                <WishCard key={index}>
                  <div className="wrapper">
                    <div className="profile">
                      {!this.containsDefaultPng(data.profile_image)?
                        <img src={ImageUrl + "/" + data.profile_image} />:
                        <UserInitialsMain size={"24px"} border isBg color="#184A61" >{`${getInitials(data?.name)}`}</UserInitialsMain>}
                    </div>
                    <div className="details">
                      <div className="name">{data.name}</div>
                      <div className="date">{convertMonthFromDate(moment(data.work_anniversary).format('D, MMMM'), this.props)} | {data?.years_completed}</div>
                      <div className="location"> { data?.department ? data?.department:null} {data?.department && data?.location!=="" && ' | '} {data?.location ? data?.location?.replace(/,/g, '') : null}</div>
                      {user?.uid!=data?.uid?<WishButton  isWidth={"262px"} disable={data?.show_recognition?0:1} onClick={data?.show_recognition?() => this.handleRequestAnniversary(data):null}>
                        {data?.show_recognition ? "Share a Post" : "Posted"}
                      </WishButton>:<WishButton isWidth={"262px"} disable>Posted</WishButton>}
                    </div>
                  </div>
      
                </WishCard>
              )):
              null
            }
          </div>:null}
          {anniversaryList && anniversaryList.upcoming_anniversary && anniversaryList.upcoming_anniversary.length?<div className="title">{this.props.t("Upcoming")}</div>:null}
          {anniversaryList && anniversaryList.upcoming_anniversary && anniversaryList.upcoming_anniversary.length?<div className="birthdayWrapper">
            {anniversaryList && anniversaryList.upcoming_anniversary && anniversaryList.upcoming_anniversary.length?
              anniversaryList.upcoming_anniversary.map((data, index) => (
                <WishCard key={index}>
                  <div className="wrapper">
                    <div className="profile">
                      {!this.containsDefaultPng(data.profile_image)?
                        <img src={ImageUrl + "/" + data.profile_image} />:
                        <UserInitialsMain size={"24px"} border isBg color="#184A61">{`${getInitials(data?.name)}`}</UserInitialsMain>}
                    </div>
                    <div className="details">
                      <div className="name">{data.name}</div>
                      <div className="date">{convertMonthFromDate(moment(data.work_anniversary).format('D, MMMM'), this.props)} | {data?.years_completed}</div>
                      <div className="location"> { data?.department ? data?.department:null}{data?.department && data?.location!=="" && ' | '}{data?.location ? data?.location?.replace(/,/g, '') : null}</div>
                    </div>
                  </div>
                </WishCard>
              )):
              null
            }
          </div>:null}
          {anniversaryList && anniversaryList.recent_anniversary && anniversaryList.recent_anniversary.length?<div className="title">{this.props.t("Previously")}</div>:null}
          {anniversaryList && anniversaryList.recent_anniversary && anniversaryList.recent_anniversary.length?<div className="birthdayWrapper">
            {anniversaryList && anniversaryList.recent_anniversary && anniversaryList.recent_anniversary.length?
              anniversaryList.recent_anniversary.map((data, index) => (
                <WishCard key={index}>
                  <div className="wrapper">
                    <div className="profile">
                      {!this.containsDefaultPng(data.profile_image)?
                        <img src={ImageUrl + "/" + data.profile_image} />:
                        <UserInitialsMain size={"24px"} border isBg color="#184A61">{`${getInitials(data?.name)}`}</UserInitialsMain>}
                    </div>
                    <div className="details">
                      <div className="name">{data.name}</div>
                      <div className="date">{convertMonthFromDate(moment(data.work_anniversary).format('D, MMMM'), this.props)} | {data?.years_completed}</div>
                      <div className="location"> { data?.department ? data?.department:null} {data?.department && data?.location!="" && ' | '} {data?.location ? data?.location?.replace(/,/g, '') : null}</div>
                      {user?.uid!=data?.uid?<PreviousButton disable={data?.show_recognition?0:1} onClick={data?.show_recognition?() => this.handleRequestAnniversary(data,1):null}>
                        {data?.show_recognition ? "Share a Post" : "Posted"}
                      </PreviousButton>:<PreviousButton disable>Posted</PreviousButton>}
                    </div>
                  </div>
                
                </WishCard>
              )):
              <NoData>No work anniversaries found in the selected filter</NoData>
            }
          </div>:null}
        </BirthdayWrapper>:
          <BirthdayWrapper style={{display:"block"}}>
            {anniversaryBirthdayUsersData && anniversaryBirthdayUsersData?.work_anniversary?.length > 0 && <div className="title">{currentMonthCountStore==date.getMonth()+1?"This month": currentMonthCountStore<date.getMonth()+1?this.props.t("Previously"): this.props.t("Upcoming")}</div>}
            <div className="birthdayWrapper">
              {anniversaryBirthdayUsersData && anniversaryBirthdayUsersData?.work_anniversary?.length>0?
                anniversaryBirthdayUsersData?.work_anniversary?.map((data, index) => {
                  const anniversaryDate = moment(data.work_anniversary); // Parse the birthday date
                  const currentDate = moment(); // Get the current date
              
                  // Extract month and day for comparison
                  const anniversaryMonth = anniversaryDate.month(); // 0-11 (January is 0)
                  const anniversaryDay = anniversaryDate.date(); // 1-31
                  const currentMonth = currentDate.month(); // 0-11
                  const currentDay = currentDate.date(); // 1-31
              
                  // Show button for past months entirely, or current month up to today
                  const selectedMonthNum = Array.isArray(currentMonthCountStore) ? currentMonthCountStore[0] : currentMonthCountStore;
                  const todayMonthNum = date.getMonth() + 1;
                  const isAnniversaryVisible = selectedMonthNum < todayMonthNum ||
                    (anniversaryMonth === currentMonth && anniversaryDay <= currentDay);
                  return(
                    <WishCard key={index}>
                      <div className="wrapper">
                        <div className="profile">
                          {!this.containsDefaultPng(data.profile_image)?
                            <img src={ImageUrl + "/" + data.profile_image} />:
                            <UserInitialsMain size={"24px"} border isBg color="#184A61">{`${getInitials(data?.full_name)}`}</UserInitialsMain>}
                        </div>
                        <div className="details">
                          <div className="name">{data.full_name}</div>
                          <div className="date">{convertMonthFromDate(moment(data.work_anniversary).format('D, MMMM'), this.props)} | {data?.years_completed}</div>
                          <div className="location"> { data?.department ? data?.department:null} {data?.department && data?.location!="" && ' | '} {data?.location ? data?.location?.replace(/,/g, '') : null}</div>
                          {isAnniversaryVisible&&user?.uid!=data?.uid?<WishButton isWidth={"262px"} disable={data?.show_recognition?0:1} onClick={data?.show_recognition?() => this.handleRequestAnniversary({...data, name: data.full_name},1):null}>
                            {data?.show_recognition ? "Share a Post" : "Posted"}
                          </WishButton>:/*<WishButton isWidth={"262px"} disable>Posted</WishButton>*/null}
                        </div>
                      </div>
                    
                    </WishCard>)}):<NoData>No work anniversaries found in the selected filter</NoData>}</div>
          </BirthdayWrapper>}
      </StyledModalV1>
    );
  }
}

BirthdayWishPopup.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  getAmigoBirthday: PropTypes.func,
  getAmigoBirthdayForManagerView: PropTypes.func,
  birthdayList: PropTypes.object,
  getWorkAnniversary: PropTypes.func,
  getWorkAnniversaryForManagerView : PropTypes.func,
  peerCallBack: PropTypes.func,
  anniversaryList: PropTypes.object,
  index: PropTypes.number,
  t: PropTypes.func,
  isAnniversaryCard: PropTypes.number,
  isBirthdayCard: PropTypes.number,
  show: PropTypes.bool,
  hidePopup: PropTypes.func,
  showBirthday: PropTypes.bool,
  fetchAnniversaryBirthdayUsers: PropTypes.func,
  anniversaryBirthdayUsersData: PropTypes.array,
  getCompanyLocation: PropTypes.func,
  getCompanyDepartment: PropTypes.func,
  departmentDetails: PropTypes.array,
  locationDetails: PropTypes.array,
  popupType: PropTypes.string,
  user: PropTypes.object,
  location: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  birthdayList: state.social.birthdayList,
  anniversaryList: state.profileData.workAnniversaryList,
  anniversaryBirthdayUsersData: state.social.anniversaryBirthdayUsersData,
  departmentDetails: state.companyDashboard.companyPeopleDepartment,
  locationDetails: state.companyDashboard.companyPeopleLocation,
  user: state.profileData.user
});

const mapDispatchToProps = (dispatch) => ({
  getAmigoBirthdayForManagerView: () => dispatch(getAmigoBirthdayForManagerView()),
  getAmigoBirthday: () => dispatch(getAmigoBirthday()),
  getWorkAnniversary: () => dispatch(getWorkAnniversary()),
  getWorkAnniversaryForManagerView: () => dispatch(getWorkAnniversaryForManagerView()),
  fetchAnniversaryBirthdayUsers: () => dispatch(fetchAnniversaryBirthdayUsers()),
  getCompanyLocation: (id,bool) => dispatch(getCompanyLocation(id,bool)),
  getCompanyDepartment: (id,bool) => dispatch(getCompanyDepartment(id,bool))
});

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(withTranslation()(BirthdayWishPopup)));